 <template>
  <div class="flow tutorial-item">
    <div class="aside">
      <div class="title">
        <i class="icon icon-caidangongneng"></i>
        <span v-if="type === 'add'">{{
          $t('training_tutorial_item.xzcpzn')
        }}</span>
        <span v-if="type === 'edit'">{{
          $t('Common.com_edit')
        }}</span>
      </div>
      <t-step v-model="step" :list="stepList" @step="onStepChange"></t-step>
    </div>
    <!-- 内容区域 -->
    <div class="section">
      <tutorial-step-info
        v-if="step === 1"
        :productId="productId"
        @cancel="onCancel"
        @step="onStep"
        @update="onUpdate"
      ></tutorial-step-info>
      <tutorial-step-video
        v-if="step === 2"
        :productId="productId"
        :productCode="productCode"
        :langCode="langCode"
        @cancel="onCancel"
        @onBack="onBack"
        @step="onStep"
        @update="onUpdate"
      >
      </tutorial-step-video>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import tStep from '@/components/step.vue';
import tutorialStepInfo from './tutorial_step_info.vue';
import tutorialStepVideo from './tutorial_step_video.vue';

export default {
  name: 'tutorial_item',
  components: {
    tStep,
    tutorialStepInfo,
    tutorialStepVideo

  },
  data() {
    return {
      productId: '',
      productCode: '',
      langCode: '',
      type: '',
      step: 1,
      // 编辑视频进来第一次
      flag: true
    };
  },
  computed: {
    stepList() {
      const list = [
        {
          label: 1,
          value: 1,
          title: this.$t('training_tutorial_item.chan_pin_xing_hao'),
          subTitle: this.$t('training_tutorial_item.xhxxtx')
        },
        {
          label: 2,
          value: 2,
          title: this.$t('training_tutorial_item.xing_hao_shi_pin'),
          subTitle: this.$t('training_tutorial_item.xhspgl')
        }
      ];
      return list;
    }
  },
  mounted: function () {
    this.productId = this.getJump('productId') || '';
    this.type = this.productId ? 'edit' : 'add';

    this.clearKeepAlive('tutorial');
    if (this.type === 'edit') {

      this.getProductDetail();

    }

  },
  methods: {
    onStepChange(step) {
      if (this.type === 'edit') {
        this.step = step;
      }
    },
    // 获取产品详情
    getProductDetail: function () {
      if (this.productId) {
        this.$getJSON(apis.tmsProductInfo, {
          productId: this.productId
        }).then((res) => {
          this.form = res.data;
          this.onUpdate(res.data);
        });
      }
    },
    // 取消
    onCancel: function () {
      this.clearTagByKeep('tutorial_item');
      this.jump('/tutorial', { langCode: this.langCode }, true);
    },
    // 上一步
    onBack: function () {
      this.step--;
    },
    // 下一步
    onStep: function (val) {
      this.clearKeepAlive('tutorial');
      if (val && val.name === 'info') {
        this.productId = val.productId;
        this.productCode = val.productCode;
        this.langCode = val.langCode;
      }
      this.step++;
    },
    onUpdate: function (val) {
      this.productId = val.productId;
      this.productCode = val.productCode;
      this.langCode = val.langCode;
      this.hasStep();
    },
    hasStep() {
      if (this.getJump('step') && this.flag) {
        this.step = +this.getJump('step');
        this.flag = false;
      }
    }
  }
};
</script>

<style lang="scss">
@import "@/style/colors.scss";
.tutorial-item {

}
</style>
